import {Button, Row} from "antd";
import styled from "styled-components";

export const SelectButtonContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
        margin-bottom: 0;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
    }
`;

export const DetailButton = styled(Button)`
    @media (max-width: 768px) {
        min-width: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const AuthorizationManagementRow = styled(Row)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
    }
`;

export const AuthorizationManagementActions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }
`;

export const TransferResponsiveWrapper = styled.div`
    /* .ant-transfer-list flex item olduğundan min-width'i varsayılan "auto"; içindeki
    Table max-content genişliğine göre büyüyüp modalın dışına taşıyordu. 0'a sabitleyip
    taşmayı Table'ın kendi yatay scroll'una (scroll={{x: "max-content"}}) bırakıyoruz. */
    .ant-transfer-list {
        min-width: 0;
    }

    @media (max-width: 768px) {
        .ant-transfer {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .ant-transfer-list {
            width: 100% !important;
        }

        .ant-transfer-operation {
            width: 100%;
            margin: 0 !important;
            display: flex;
            justify-content: center;
        }
    }
`;
